<template>
    <el-dialog title="异常处理" :visible.sync="dialogVisible" width="60%">
        <div class="box-card" v-if="Object.keys(infoData).length">
            <div v-for="(item,index) in infoData.productInfos" :key="index">
            <el-row class="custom-container">
                <el-col :span="4">
                    <el-image
                        style="width: 100%; height: 100%;"
                        :src="item.imageUrl"
                        :z-index="2200"
                        :preview-src-list="item.imageUrl.split(',')"
                    ></el-image>
                </el-col>
                <el-col :span="18" :offset="2">
                    <div class="inform flex">
                        <div class="title">亚马逊订单号：</div>
                        <div>{{ infoData.amazonOrderId }}</div>
                    </div>
                    <div class="inform flex">
                        <div class="title">标题：</div>
                        <div>{{ item.title }}</div>
                    </div>
                    <div class="inform flex">
                        <div class="title">SKU：</div>
                        <div>{{ item.sku }}</div>
                    </div>
                    <el-row type="flex" justify="space-between">
                        <div class="inform flex">
                            <div class="title">数量：</div>
                            <div>{{ item.quantityOrdered }}</div>
                        </div>
                        <!-- <el-button type="text">打印（0）</el-button> -->
                    </el-row>
                </el-col>
            </el-row>
            </div>
            <div class="custom-container">
                <div style="width:100%;">
                    <div style="width:100%;">
                        <el-divider></el-divider>
                        <el-row>
                            <el-col :span="8">
                                <div class="inform">采购单据号：{{ infoData.purchaseNumber }}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="inform">运单号：{{ infoData.internalConveyNumber }}</div>
                            </el-col>
                        </el-row>
                        <div class="inform">海逊仓库核对详情：{{ infoData.purchaseModel }}</div>
                        <el-row>
                            <el-col :span="8">
                                <div class="inform">入库尺寸：{{ infoData.purchaseSize }}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="inform">入库重量：{{ infoData.purchaseWeight }}</div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <div class="inform">材积重：{{ infoData.purchaseSize }}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="inform">计费重：{{ infoData.purchaseWeight }}</div>
                            </el-col>
                        </el-row>
                        <div class="inform">货物等级：{{ infoData.purchaseClass }}</div>
                        <div class="inform">
                            <h4>异常信息：</h4>
                            <div style="padding:0 10px;">
                                <template v-for="item in infoData.exceptionImages">
                                    <el-image
                                        :z-index="2200"
                                        :key="item"
                                        style="width: 100px; height: 100px"
                                        :src="item"
                                        :preview-src-list="[item]"
                                        fit="fit"
                                    ></el-image>
                                    <!-- <el-image :key="item" :src="item"></el-image> -->
                                </template>
                                <div class="inform" style="color: red;">{{ infoData.exceptionRemark }}</div>
                            </div>
                        </div>
                        <el-row type="flex" align="middle" style="margin: 10px 0;">
                          <h4>处理方案：</h4>
                          <el-input style="width: 500px;margin: 0 10px;" v-model="handleDescription"></el-input>
                          <el-button type="primary" @click="saveHandleDescription" v-if="infoData.exceptionResult === 0">保存</el-button>
                        </el-row>

                        <el-row type="flex" justify="end">
                            <el-button v-if="infoData.outInterceptStatus&&this.str.superDepartmentName == '采购部'" type="primary" :loading="loadingStatus === 'loadingIntercept'" @click="cancelIntercept">
                              取消拦截
                            </el-button>
                            <el-button v-if="infoData.ifCancel" type="primary" @click="infoChange('Cancel')">
                                取消异常
                            </el-button>
                            <!-- <el-button v-if="infoData.ifPutStorage" type="primary" @click="turnStock">
                                转库存
                            </el-button> -->
                            <el-button v-if="infoData.ifReturn" type="primary" @click="openInnerDialog">
                                退件
                            </el-button>

                            <el-tooltip  v-if="infoData.ifUnknown" class="item" effect="dark" content="该功能适用于将A订单的异常件转未知库存后，经库房确认转未知再匹配给B订单" placement="top">
                                <el-button type="primary" @click="turnUnknown">
                                    转未知
                                </el-button>
                            </el-tooltip>
                            
                        </el-row>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog title="退件处理" width="50%" :visible.sync="innerVisible" append-to-body>
            <el-row type="flex">
                <el-button type="text" @click="fifthVisible = true">新增地址</el-button>
                <el-button type="text" @click="openThirdDialog">选择地址</el-button>
            </el-row>
            <div class="out-handle-box">
                <el-row type="flex">
                    <h4>收件人：</h4>
                    <p>{{ this.innerData.recipientName }}</p>
                </el-row>
                <el-row type="flex">
                    <h4>收货地址：</h4>
                    <p>{{ this.innerData.receivingAddress }}</p>
                </el-row>
                <el-row type="flex">
                    <h4>收件人电话：</h4>
                    <p>{{ this.innerData.recipientTelephone }}</p>
                </el-row>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="innerVisible = false">取 消</el-button>
                <el-button type="primary" @click="infoChange('Return')">确 定</el-button>
            </div>

            <el-dialog width="40%" title="选择地址" :visible.sync="thirdVisible" append-to-body>
                <el-table :data="tableThird" border>
                    <!-- <el-table-column type="selection" width="50" align="center"></el-table-column> -->
                    <el-table-column
                        property="recipientName"
                        label="收件人"
                        width="100"
                        align="center"
                    ></el-table-column>
                    <el-table-column property="receivingAddress" label="收件地址" align="center"></el-table-column>
                    <el-table-column
                        property="recipientTelephone"
                        label="电话"
                        width="200"
                        align="center"
                    ></el-table-column>
                    <el-table-column label="操作" width="140" align="center">
                        <template slot-scope="scope">
                            <el-button type="primary" @click="addressConfirm(scope.row)">选择</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="thirdVisible = false">取 消</el-button>
                    <!-- <el-button type="primary" @click="infoChange('Return')">确 定</el-button> -->
                </div>
            </el-dialog>

            <el-dialog width="600px" title="新增地址" :visible.sync="fifthVisible" append-to-body>
              <el-form label-width="100px">
                <el-form-item label="收货地址">
                  <el-input v-model="fifthForm.receivingAddress"></el-input>
                </el-form-item>
                <el-form-item label="收件人">
                  <el-input v-model="fifthForm.recipientName"></el-input>
                </el-form-item>
                <el-form-item label="收件人电话">
                  <el-input v-model="fifthForm.recipientTelephone"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="fifthVisible = false">取 消</el-button>
                 <el-button type="primary" @click="increaseAddress">确 定</el-button>
              </div>
            </el-dialog>

        </el-dialog>
        <el-dialog width="40%" title="提示" :visible.sync="fourthVisible" append-to-body>
            <el-form :model="formFourth" label-width="100px">
                <el-form-item label="海逊仓库核对详情" style="width: 100%;">
                    <el-input  style="width: 100%;" v-model="formFourth.purchaseDemand"></el-input>
                </el-form-item>
                <el-col :span="6">
                    <el-form-item label="采购价">
                        <el-input v-model="formFourth.purchasePrice"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="返佣" label-width="60px">
                        <el-input v-model="formFourth.rebatePrice"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="其它费用">
                        <el-input v-model="formFourth.otherPrice"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item label="类型" label-width="60px">
                        <el-select
                            v-model="formFourth.purchaseTypeCode"
                            placeholder="请选择"
                            filterable
                            value-key="itemTypeId"
                        >
                            <el-option
                                v-for="item in logisticsList"
                                :key="item.id"
                                :label="item.itemTypeName"
                                :value="item.itemTypeId"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="物流公司">
<!--                        <el-input v-model="formFourth.logisticsCompany"></el-input>-->
                        <el-select v-model="logisticsCompany" filterable placeholder="请选择" value-key="id">
                          <el-option
                              v-for="item in Logistics"
                              :key="item.value"
                              :label="item.logisticsCompanyName"
                              :value="item">
                          </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="13">
                    <el-form-item label="运单号码">
                        <el-input v-model="formFourth.internalConveyNumber"></el-input>
                    </el-form-item>
                </el-col>
                <el-col>
                    <el-form-item label="采购备注">
                        <el-input v-model="formFourth.remark"></el-input>
                    </el-form-item>
                </el-col>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submitFourth" :loading="isLoading">保 存</el-button>
            </div>
        </el-dialog>

        <el-dialog width="70%" title="采购" :visible.sync="cancelList" append-to-body :before-close="handleClose" :close-on-click-modal="false">
            <el-button type="primary" :loading="btnloading" @click="matching" :disabled="btndisabled">匹配库存</el-button>
            <el-button type="primary" :loading="btnloading" @click="HXShops" :disabled="btndisabled">海逊商城</el-button>

            <el-table :data="ReturninventoryList" style="width: 100%;margin-top:15px;" border>
                <el-table-column prop="inventoryNumber" label="库存编号" align="center"></el-table-column>
                <el-table-column label="图片" align="center" width="90">
                    <template slot-scope="scope">
                        <img :src="scope.row.images" alt="" style="width:60px;height:60px;">
                    </template>
                </el-table-column>
                <el-table-column prop="productFullName" label="全称" align="center"></el-table-column>
                <el-table-column prop="productSimpleName" label="简称" align="center"></el-table-column>
                <el-table-column prop="productDescription" label="描述" align="center"></el-table-column>
                <el-table-column prop="actualCount" label="库存数量" align="center" width="80"></el-table-column>
                <el-table-column  label="使用数量" align="center" width="160">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.useCount" :disabled="btndisabled" :min="1" :max="scope.row.actualCount" size="mini"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="核对备注" align="center">
                    <template slot-scope="scope">
                        <el-input type="textarea" v-model="scope.row.purchaseDemandRemark" :disabled="btndisabled"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="danger" @click="delSave(scope.row)" :disabled="btndisabled">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-table :data="ReturninventoryList1" style="width: 100%;margin-top:15px;" border>
                <el-table-column label="图片" align="center" width="90">
                    <template slot-scope="scope">
                        <img :src="scope.row.images" alt="" style="width:60px;height:60px;">
                    </template>
                </el-table-column>
                <el-table-column prop="productFullName" label="全称" align="center"></el-table-column>
                <el-table-column prop="productSimpleName" label="简称" align="center"></el-table-column>
                <el-table-column prop="productDescription" label="描述" align="center"></el-table-column>
                <el-table-column prop="originalPrice" label="原价" align="center"></el-table-column>
                <el-table-column prop="currentPrice" label="现价" align="center"></el-table-column>
                <el-table-column prop="actualCount" label="库存数量" align="center" width="80"></el-table-column>
                <el-table-column  label="使用数量" align="center" width="160">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.useCount" :disabled="btndisabled" :min="1" :max="scope.row.actualCount" size="mini"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="核对备注" align="center">
                    <template slot-scope="scope">
                        <el-input type="textarea" v-model="scope.row.purchaseDemandRemark" :disabled="btndisabled"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="danger" @click="delSave1(scope.row)" :disabled="btndisabled">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-table :data="searchData" border style="width: 100%;margin-top:15px;">
                <el-table-column prop="orderId" label="订单号" align="center" width="150"></el-table-column>
                <el-table-column prop="" label="产品信息" align="center" width="250">
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.productInfos" :key="item.id">
                            <div class="product">
                                <el-popover trigger="hover" placement="bottom-start">
                                    <img :src="item.imageUrl" alt  style="width:200px;height:200px;"/>
                                    <div class="scope_img" slot="reference">
                                        <img :src="item.imageUrl" alt style="width:50px;height:50px;margin-left:10px;"/>
                                    </div>
                                </el-popover>
                                <div style="margin-left:10px;">
                                    <p>price:{{item.itemAmount}} {{item.itemCurrencyCode}}</p>
                                    <p>SKU:{{item.sku}}</p>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="采购单据号" align="center">
                    <template slot-scope="scope">
                        <p v-for="(item,index) in scope.row.purchases" :key="index" :title="item.checkResult == 2 ? item.exceptionRemark : ''" :class="item.checkResult == 2 ? 'redFont' : ''" class="danjuremark">{{item.purchaseNumber}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="采购价" align="center" width="80">
                    <template slot-scope="scope">
                        <p v-for="(item,index) in scope.row.purchases" :key="index" class="danjuremark">
                            <span v-if="item.purchasePrice!==''&&item.purchasePrice!==null">{{item.purchasePrice}}</span>
                            <span v-if="item.purchasePrice==''||item.purchasePrice==null">--</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="物流公司" align="center" width="100">
                    <template slot-scope="scope">
                        <p v-for="(item,index) in scope.row.purchases" :key="index" class="danjuremark">
                            <span v-if="item.logisticsCompany!==''&&item.logisticsCompany!==null">{{item.logisticsCompany}}</span>
                            <span v-if="item.logisticsCompany==''||item.logisticsCompany==null">--</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="国内运单号" align="center">
                    <template slot-scope="scope">
                        <p v-for="(item,index) in scope.row.purchases" :key="index" class="danjuremark">
                            <span v-if="item.internalConveyNumber!==''&&item.internalConveyNumber!==null">{{item.internalConveyNumber}}</span>
                            <span v-if="item.internalConveyNumber==''||item.internalConveyNumber==null">--</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="是否无效" align="center" width="80">
                    <template slot-scope="scope">
                        <p v-for="(item,index) in scope.row.purchases" :key="index" class="danjuremark">
                            <span v-if="item.invalidStatus == 1">正常</span>
                            <span v-if="item.invalidStatus == 0" style="color:red;">无效</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="230">
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.purchases" :key="index" class="danjuremark">
                            <el-tooltip class="item" effect="dark" :content="item.purchaseModel" placement="top">
                                <el-button type="primary" @click="toView(item)">查看</el-button>
                            </el-tooltip>
                            <el-button type="danger" @click="taginvalid(item)" :disabled="item.invalidStatus == 0">标记为无效单据</el-button>
                        </div>
                        <!-- <el-button type="primary" @click="determine(scope.row)">确定</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <el-row v-show="isShow">
                <p style="color:red;margin-top:15px;">提示：如无需匹配库存/商城或新增采购单，可直接点击取消异常，取消异常后将正常发货。</p>
                <p style="color:red;">请务必将无用的采购单据标记为无效状态，库房将对该无效状态的单据不进行信息核对!</p>
            </el-row>

            <div slot="footer" class="dialog-footer">
                <div>
                    <el-button type="success" @click="Add">新增</el-button>
                    <el-button type="primary" v-show="isShow" @click="cancelEC('Cancel')">取消异常</el-button>
                    <el-button type="primary" v-show="isShow1" @click="Saves">保存</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog top="5vh"  width="45%" title="库存" :visible.sync="innerVisibles" append-to-body>
            <el-tabs v-model="activeName" type="card">
                <el-tab-pane label="全部库存" name="first">
                    <el-input v-model="searchString" placeholder="库存编号、商品全称、商品简称" style="width:70%;"></el-input>
                    <el-button type="primary" style="margin-left:15px;" @click="matchingAjax">搜索</el-button>
                    <el-table :data="inventoryList" border height="560" style="width: 100%;margin-top:15px;" @selection-change="handleSelectionChange1" v-loading="tableLoading1">
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="inventoryNumber" label="库存编号" align="center"></el-table-column>
                            <el-table-column label="图片" align="center" width="90">
                                <template slot-scope="scope">
                                    <el-image 
                                        style="width: 60px; height: 60px"
                                        :src="scope.row.imagesList[0]" 
                                        :preview-src-list="scope.row.imagesList">
                                    </el-image>
                                </template>
                            </el-table-column>
                            <el-table-column prop="productFullName" label="全称" align="center"></el-table-column>
                            <el-table-column prop="productSimpleName" label="简称" align="center"></el-table-column>
                            <el-table-column prop="productDescription" label="描述" align="center"></el-table-column>
                            <el-table-column prop="actualCount" label="库存数量" align="center" width="80"></el-table-column>
                        </el-table>
                        <el-pagination
                            style="text-align: center;margin-top:10px;"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[20, 50, 100, 200]"
                            :page-size="pagesize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total"
                        ></el-pagination>
                </el-tab-pane>
                <el-tab-pane label="已匹配库存" name="second">
                        <el-table :data="inventoryList1" border height="550" style="width: 100%;margin-top:15px;" @selection-change="handleSelectionChange_1" v-loading="tableLoading1">
                                <el-table-column type="selection" width="55"></el-table-column>
                                <el-table-column prop="inventoryNumber" label="库存编号" align="center"></el-table-column>
                                <el-table-column label="图片" align="center" width="90">
                                    <template slot-scope="scope">
                                        <el-image 
                                            style="width: 60px; height: 60px"
                                            :src="scope.row.imagesList[0]" 
                                            :preview-src-list="scope.row.imagesList">
                                        </el-image>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="productFullName" label="全称" align="center"></el-table-column>
                                <el-table-column prop="productSimpleName" label="简称" align="center"></el-table-column>
                                <el-table-column prop="productDescription" label="描述" align="center"></el-table-column>
                                <el-table-column prop="actualCount" label="库存数量" align="center" width="80"></el-table-column>
                            </el-table>
                            <el-pagination
                                style="text-align: center;margin-top:10px;"
                                @size-change="handleSizeChange1"
                                @current-change="handleCurrentChange1"
                                :current-page="currentPage1"
                                :page-sizes="[20, 50, 100, 200]"
                                :page-size="pagesize1"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total1"
                            ></el-pagination>
                </el-tab-pane>
            </el-tabs>
                
                    <div slot="footer" class="dialog-footer">
                        <div>
                            <el-button @click="innerVisibles = false">关闭</el-button>
                            <el-button type="primary" @click="save">保存</el-button>
                        </div>
                    </div>
        </el-dialog>

        <el-dialog title="海逊商城" :visible.sync="Hymall" width="50%" append-to-body>
            <div>
                <el-input v-model="ShopsString" style="width:82%;"></el-input>
                <el-button type="primary" style="margin-left:10px;" @click="HXShopsSearch">搜索</el-button>
                <el-button type="primary" @click="HXShopsReset">重置</el-button>
            </div>
            <div style="margin-top:15px;">
                <el-table :data="GoodsMall" border style="width: 100%" @selection-change="handleSelectionChange2" v-loading="tableLoading2">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column label="图片" align="center" width="90">
                        <template slot-scope="scope">
                            <el-image 
                                style="width: 60px; height: 60px"
                                :src="scope.row.imagesList[0]" 
                                :preview-src-list="scope.row.imagesList">
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productFullName" label="全称" align="center"></el-table-column>
                    <el-table-column prop="productSimpleName" label="简称" align="center"></el-table-column>
                    <el-table-column prop="originalPrice" label="原价" align="center"></el-table-column>
                    <el-table-column prop="currentPrice" label="现价" align="center"></el-table-column>
                    <el-table-column prop="productDescription" label="描述" align="center"></el-table-column>
                    <el-table-column prop="actualCount" label="库存数量" align="center"></el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <div>
                    <el-button @click="Hymall = false">关闭</el-button>
                    <el-button type="primary" @click="save1">保存</el-button>
                </div>
            </div>
        </el-dialog>

        <!-- 添加采购单 -->
        <el-dialog width="54%" top="30vh" title="添加采购单" :visible.sync="AddinnerVisible" append-to-body>
            <el-row class="border-bottom padding">
                <el-col :span="25">
                    <el-row>
                        <el-col class="padding" :span="20">
                            <el-input v-model="purchaseModel1">
                                <template slot="prepend">
                                    <el-tooltip content="完整描述海逊仓库核对的细节，海逊仓库将按照此详情核对" placement="top">
                                        <el-button>海逊仓库核对详情:</el-button>
                                    </el-tooltip>
                                </template>
                            </el-input>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col class="padding" :span="5">
                            <el-input v-model="purchasePrice1">
                                <template slot="prepend">
                                    采购价:
                                </template>
                            </el-input>
                        </el-col>
                        <el-col class="padding" :span="5">
                            <el-input v-model="rebatePrice1">
                                <template slot="prepend">
                                    <el-tooltip content="购买后,卖家返回的佣金" placement="top">
                                        <el-button>返佣:</el-button>
                                    </el-tooltip>
                                </template>
                            </el-input>
                        </el-col>
                        <el-col class="padding" :span="5">
                            <el-input v-model="otherPrice1">
                                <template slot="prepend">
                                    退款费用:
                                </template>
                            </el-input>
                        </el-col>
                        <el-col class="padding" :span="5">
                            <span class="leix">类型:</span>
                            <el-select
                                v-model="purchaseTypeCode1"
                                placeholder="请选择"
                                style="width: 77%;"
                                class="logistics"
                            >
                                <el-option
                                    v-for="item in this.selectType"
                                    :key="item.value"
                                    :label="item.itemTypeName"
                                    :value="item.itemTypeName"
                                ></el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col class="padding" :span="5">
                            <span class="leix">物流公司:</span>
                            <el-select v-model="logisticsCompany1" @change="SelectLogistics1" value-key="id" filterable clearable placeholder="请选择" style="width: 62%;" class="logistics">
                                <el-option
                                v-for="item in Logistics"
                                :key="item.id"
                                :label="item.logisticsCompanyName"
                                :value="item">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col class="padding" :span="15">
                            <el-input v-model.trim="internalConveyNumber1" onkeyup="value=value.replace(/[^\x00-\xff]/g, '')">
                                <template slot="prepend">
                                    运单号码:
                                </template>
                            </el-input>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col class="padding" :span="20">
                            <el-input v-model="remark1">
                                <template slot="prepend">
                                    <el-tooltip content="填写对应的采购平台的订单号，方便补充运单号，此备注仅自己可见" placement="top">
                                        <el-button>采购备注:</el-button>
                                    </el-tooltip>
                                </template>
                            </el-input>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <p style="margin-top:15px;color:red;">
                注：请补充填写该单据空白处所需要的信息！
            </p>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="determine()" :loading="isLoading">保存</el-button>
                <el-button @click="AddPurchasebCancel">取消</el-button>
            </div>
        </el-dialog>

        <!-- 查看采购单 -->
        <el-dialog width="54%" top="30vh" title="查看采购单" :visible.sync="AddinnerVisible1" append-to-body>
            <el-row class="border-bottom padding">
                <el-col :span="25">
                    <el-row>
                        <el-col class="padding" :span="20">
                            <el-input v-model="purchaseModel2" disabled>
                                <template slot="prepend">
                                    <el-tooltip content="完整描述海逊仓库核对的细节，海逊仓库将按照此详情核对" placement="top">
                                        <el-button>海逊仓库核对详情:</el-button>
                                    </el-tooltip>
                                </template>
                            </el-input>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col class="padding" :span="5">
                            <el-input v-model="purchasePrice2" disabled>
                                <template slot="prepend">
                                    采购价:
                                </template>
                            </el-input>
                        </el-col>
                        <el-col class="padding" :span="5">
                            <el-input v-model="rebatePrice2" disabled>
                                <template slot="prepend">
                                    <el-tooltip content="购买后,卖家返回的佣金" placement="top">
                                        <el-button>返佣:</el-button>
                                    </el-tooltip>
                                </template>
                            </el-input>
                        </el-col>
                        <el-col class="padding" :span="5">
                            <el-input v-model="otherPrice2" disabled>
                                <template slot="prepend">
                                    退款费用:
                                </template>
                            </el-input>
                        </el-col>
                        <el-col class="padding" :span="5">
                            <span class="leix">类型:</span>
                            <el-input v-model="purchaseTypeCode2" disabled style="width: 77%;" class="logistics"></el-input>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col class="padding" :span="5">
                            <span class="leix">物流公司:</span>
                            <el-input v-model="logisticsCompany2" disabled style="width: 62%;" class="logistics"></el-input>
                        </el-col>
                        <el-col class="padding" :span="15">
                            <el-input v-model.trim="internalConveyNumber2" disabled>
                                <template slot="prepend">
                                    运单号码:
                                </template>
                            </el-input>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col class="padding" :span="20">
                            <el-input v-model="remark2" disabled>
                                <template slot="prepend">
                                    <el-tooltip content="填写对应的采购平台的订单号，方便补充运单号，此备注仅自己可见" placement="top">
                                        <el-button>采购备注:</el-button>
                                    </el-tooltip>
                                </template>
                            </el-input>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>

        </el-dialog>



        <Addinventory ref="Addinventory" @confirm="AddinventoryConfirm" />
    </el-dialog>
</template>
<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
import Addinventory from "./Addinventory";

export default {
    name: "Abnormaldetails",
    components: {
        Addinventory,
    },
    data() {
        return {
            dialogVisible: false,
            innerVisible: false,
            thirdVisible: false,
            fourthVisible: false,
            cancelList:false,
            infoData: {},
            innerData: {},
            tableThird: [],
            logisticsCompany: '',
            formFourth: {
                purchaseDemand: '',
                purchasePrice: '',
                rebatePrice: '',
                otherPrice: '',
                purchaseTypeCode: '',
                logisticsCompany: '',
                internalConveyNumber: '',
                remark: ''
            },
            logisticsList: [],
            isLoading:false,
            loadingStatus: '',
            Logistics: [],
            fifthVisible: false,
            fifthForm: {
              receivingAddress: '',
              recipientName: '',
              recipientTelephone: ''
            },
            handleDescription: '',

            currentPage: 1,
            pagesize: 20,
            size: 20,
            total: 0,

            currentPage1: 1,
            pagesize1: 20,
            size1: 20,
            total1: 0,

            activeName:"first",

            str:"",
            ReturninventoryList:[],
            ReturninventoryList1:[],
            ReturninventoryLists:[],
            ReturninventoryLists1:[],
            ReturninventoryList1s:[],
            inventoryList:[],
            inventoryList1:[],
            AddinnerVisible1:false,
            AddinnerVisible:false,
            Hymall:false,
            innerVisibles:false,
            btnloading:false,
            btndisabled:"",
            tableLoading1:true,
            tableLoading2:true,
            searchString:"",
            id:"",
            ShopsString:"",
            GoodsMall:[],
            searchData:[],
            purchaseDemandId:"",
            selectType:"",
            Logistics:"",
            inventorySkuList:[],
            isShow:false,
            isShow1:false,

            purchasePrice1: "", //采购价
            purchaseModel1: "", //采购详情
            rebatePrice1: "", //返佣
            otherPrice1: "", //退款费用
            purchaseTypeCode1: "", //采购类型
            remark1: "", //采购备注
            internalConveyNumber1: "", //运单号码
            logisticsCompany1: "", //物流公司
            companyCode1: "", //物流公司编码

            purchasePrice2: "", //采购价
            purchaseModel2: "", //采购详情
            rebatePrice2: "", //返佣
            otherPrice2: "", //退款费用
            purchaseTypeCode2: "", //采购类型
            remark2: "", //采购备注
            internalConveyNumber2: "", //运单号码
            logisticsCompany2: "", //物流公司
            companyCode2: "", //物流公司编码
            oldHandleDescription: '',
        };
    },
    props: {
        UserInfo: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    created(){
        this.str = JSON.parse(localStorage.getItem("role"));
    },
    methods: {
        init(row) {
            this.dialogVisible = true;
            this.infoData = row;
            this.handleDescription = this.infoData.handleDescription || '';
            this.oldHandleDescription = this.handleDescription;
            ajaxPost(Baseurl + "logisticsController/getInventoryPurchaseDetails", {id:row.id,listType:row.listType}).then(res => {
                this.infoData = res.data.data;
                this.id = this.infoData.purchaseDemandId;
            });
        },
        initFourth() {
            this.getLogistics()
            this.getLogisticsList()
            this.fourthVisible = true
            this.formFourth.purchaseDemand = this.infoData.purchaseDemand
        },
        close() {
            this.dialogVisible = false;
            this.innerVisible = false;
            this.thirdVisible = false;
            this.fourthVisible = false
            this.infoData = {};
            this.innerData = {};
            this.tableThird = {};
            this.formFourth = {
                purchaseDemand: '',
                purchasePrice: '',
                rebatePrice: '',
                otherPrice: '',
                purchaseTypeCode: '',
                logisticsCompany: '',
                internalConveyNumber: '',
                remark: ''
            }
            this.$refs.Addinventory.close();
        },
        typeCode() {
            var itemCode = {
                itemCode: "HYXUN0000001",
            };
            ajaxPost(Baseurl + "purchaseController/selectItemList", itemCode).then(res => {
                this.selectType = res.data.data;
            });
        },
        LogisticsAjax(){
            ajaxPost(Baseurl + "logisticsController/getLogisticsCompanyList").then(res => {
                    if (res.data.code == 200) {
                        this.Logistics = res.data.data
                    }
            });
        },
        turnStock() {
            // console.log(this.$refs);
            this.$refs.Addinventory.init();
        },
        AddinventoryConfirm(data) {
            // console.log(JSON.parse(JSON.stringify(this.infoData)))
            // purchaseFrom
            this.infoChange("PutStorage", data);
        },
        // 信息报错 信息确认
        infoChange(type, data = {}) {
            // this.initFourth()
            // return
            const handleRequest = () => {
                 
                let paramsData = {
                    id: this.infoData.id,
                    orderId: this.infoData.orderId,
                    purchaseDemandId: this.infoData.purchaseDemandId
                };
                const operate = {
                    Cancel: () => {
                        paramsData.exceptionResult = "5";
                        paramsData.inventorys = this.ReturninventoryList
                        paramsData.mallInventorys = this.ReturninventoryList1
                        // console.log(this.ReturninventoryList)
                    },
                    PutStorage: () => {
                        this.$refs.Addinventory.loadingStatua = false;
                        paramsData.exceptionResult = "3";
                        paramsData.inventory = { ...data };
                    },
                    Return: () => {
                        paramsData.exceptionResult = "1";
                        paramsData.receivingAddressId = this.innerData.id;
                    },
                    // unknown
                    unknown: () => {
                        paramsData.roleId=this.str.rid;
                        paramsData.companyId=this.str.company_id;
                        paramsData.exceptionResult = "9";
                    },
                };
                operate[type]();
                this.$emit("confirm", paramsData);
            };
          
            if (type === 'Cancel') {
                // this.$confirm("取消异常后将<span style=\"color: red;\">正常发货</span>", "提示", {
                //     dangerouslyUseHTMLString: true
                // }).then(() => {
                //     handleRequest();
                // });
                this.cancelList = true
                this.isShow = true
                this.isShow1 = false
                this.inventoryController()
                this.demand()
            } else if(type === 'PutStorage'){
                this.$confirm("您确定要执行此操作吗？", "提示").then(() => {
                    handleRequest();
                    if(this.infoData.purchaseFrom === 1){
                        this.$confirm('是否增加一条采购单?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                            this.cancelList = true
                            this.inventoryController()
                            this.demand()
                            this.isShow = false
                            this.isShow1 = true
                        })
                    }else{
                        this.dialogVisible = false;
                    }
                });
            } else if(type === 'Return'){
                this.$confirm("您确定要执行此操作吗？", "提示",).then(() => {
                    handleRequest();
                    this.$confirm('是否增加一条采购单?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                    }).then(() => {
                            this.cancelList = true
                            this.inventoryController()
                            this.demand()
                            this.isShow = false
                            this.isShow1 = true
                    })

                });
            }else if(type==="unknown"){

                 handleRequest();
                    this.$confirm('是否增加一条采购单?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                    }).then(() => {
                            this.cancelList = true
                            this.inventoryController()
                            this.demand()
                            this.isShow = false
                            this.isShow1 = true
                    })
            }
        },
        openInnerDialog() {
            const API = Baseurl + "logisticsController/selectDefaultAddressByCompanyId";
            const paramsData = {
                companyId: this.UserInfo.company_id,
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    if(data === null){
                        this.$message.error('请先添加退件地址!');
                    }else{
                        this.innerData = data;
                        this.innerVisible = true;
                    }
                }
            });
        },
        turnUnknown(){
            this.$confirm('确定要转未知吗?', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
            }).then(() => {
                this.infoChange("unknown");
            })
        },
        openThirdDialog() {
            const API = Baseurl + "logisticsController/selectReceivingAddressListByCompanyId";
            const paramsData = {
                companyId: this.UserInfo.company_id,
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.tableThird = data;
                    this.thirdVisible = true;
                }
            });
        },
        addressConfirm(row) {
            this.innerData = row;
            this.thirdVisible = false;
        },
        submitFourth() {
            this.isLoading = true;
            const API = Baseurl + 'purchaseController/insertPurchase'
            const paramsData = {
                insertFrom:1,
                companyId: this.UserInfo.company_id,
                purchaseRoleId: this.infoData.purchaseRoleId,
                amazonOrderId: this.infoData.amazonOrderId,
                orderId: this.infoData.orderId,
                purchaseFrom: this.infoData.purchaseFrom,
                purchaseDemandId: this.infoData.purchaseDemandId,
                purchaseModel: this.infoData.purchaseModel,
                roleId: this.UserInfo.rid,
                ...this.formFourth,
                logisticsCompany: this.logisticsCompany.logisticsCompanyName,
                companyCode: this.logisticsCompany.logisticsCompanyCode
            }
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data
                if (code === 200) {
                    this.isLoading = false;
                    this.close()
                    this.$parent.getTableData()
                    this.$message.success('操作成功')
                }
            })
        },
        // 请求类型下拉框的数据
        getLogistics() {
            const API = Baseurl + "purchaseController/selectItemList";
            const paramsData = {
                itemCode: "HYXUN0000001",
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.logisticsList = data;
                }
            });
        },
        cancel(){
            this.$confirm('取消后将无法重新添加采购单据，是否取消', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.fourthVisible = false
            })
        },
        cancelIntercept() {
            this.$confirm('是否执行此操作', '提示').then(() => {
                const API = Baseurl + 'orderController/cancelOutIntercept'
                const paramsData = {
                  id: this.infoData.purchaseDemandId,
                  roleId: this.UserInfo.rid
                }
                this.loadingStatus = 'loadingIntercept'
                ajaxPost(API, paramsData).then(res => {
                  const { code } = res.data
                  this.loadingStatus = ''
                  if (code === 200) {
                    this.infoData.outInterceptStatus = false
                    this.$message.success('操作成功')
                  }
                })
            })
        },
        getLogisticsList() {
            const API = Baseurl + 'logisticsController/getLogisticsCompanyList'
            ajaxPost(API).then(res => {
                const { code, data } = res.data
                if (code === 200) {
                    this.Logistics = data
                }
            })
        },
        increaseAddress() {
            const API = Baseurl + 'receivingAddressController/insertReceivingAddress'
            const paramsData = {
                ...this.fifthForm,
                companyId: this.UserInfo.company_id
            }
            if(paramsData.receivingAddress == ""){
                    this.$message.warning("请填写收件人地址");
                    return;
              }else if(paramsData.recipientName == ""){
                   this.$message.warning("请填写收件人姓名");
                    return;
              }else if(paramsData.recipientTelephone == ""){
                   this.$message.warning("请填写收件人电话");
                    return;
              }
            ajaxPost(API, paramsData).then(res => {
                const { code } = res.data
                if (code === 200) {
                  this.fifthVisible = false
                  this.$message.success('操作成功')
                }
            })
        },
        saveHandleDescription() {
            const API = Baseurl + 'purchaseController/updateHandleDescription'
            const paramsData = {
                id: this.infoData.id,
                handleDescription: this.handleDescription
            }
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data
                if (code === 200) {
                    this.$message.success('操作成功')
                    this.$parent.getTableData()
                    if(this.oldHandleDescription == this.handleDescription){
                        return
                    }
                    if(!(this.handleDescription.trim())){
                        return
                    }
                    const logData = {
                        roleId: null,
                        purchaseId: null,
                        orderId: this.infoData.orderId,
                        message: "库房处理方案：" + this.handleDescription,
                        type: 52
                    }
                    ajaxPost(Baseurl + 'unknownManageController/insertLog', logData).then(res => {
                        const { code, data } = res.data
                    })
                    this.oldHandleDescription = this.handleDescription;
                } else {
                    this.$message.error(data || '操作失败')
                }
            })
        },


        inventoryController(){
            var obj = {
                purchaseDemandId:this.id
            }
            ajaxPost(Baseurl + "inventoryController/selectInventoryByDemandId", obj).then(res => {
                if(res.data.code == 200){
                    this.ReturninventoryList = res.data.data.inventoryOperates
                    this.ReturninventoryList1 = res.data.data.mallInventoryOperates
                    if(this.ReturninventoryList.length == 0&&this.ReturninventoryList1.length == 0){
                        this.btndisabled = false
                    }else{
                        this.btndisabled = true
                    }
                }
            });
        },
        demand(){
            var obj = {
                id:this.id
            }
            ajaxPost(Baseurl + "purchaseDemandController/selectPurchaseDemandById", obj).then(res => {
                if(res.data.code == 200){
                    this.searchData = [res.data.data]
                    this.purchaseDemandId = res.data.data
                }
            });
        },
        matching(){
            this.innerVisibles = true
            this.searchString = ""
            this.matchingAjax()
            this.matchingAjax1()
        },
        matchingAjax(){
                this.tableLoading1 = true
                var obj = {
                    companyId:this.str.company_id,
                    searchString:this.searchString,
                    page:this.currentPage,
                    size:this.size
                };
                ajaxPost(Baseurl + "inventoryController/getAllInventory", obj).then(res => {
                    if(res.data.code == 200){
                        this.inventoryList = res.data.data.list
                        this.total = res.data.data.total
                    }
                    this.tableLoading1 = false
                });
        },
        matchingAjax1(){
                this.tableLoading1 = true
                for(var i= 0;i<this.infoData.productInfos.length;i++){
                    var skus = this.infoData.productInfos[i].sku
                    this.inventorySkuList.push(skus)
                }
                var obj = {
                    companyId:this.str.company_id,
                    inventorySkuList:this.inventorySkuList,
                    page:this.currentPage1,
                    size:this.size1
                };
                ajaxPost(Baseurl + "inventoryController/getInventoryBySku", obj).then(res => {
                    if(res.data.code == 200){
                        this.inventoryList1 = res.data.data.list
                        this.total1 = res.data.data.total
                    }
                    this.inventorySkuList = []
                    this.tableLoading1 = false
                });
        },
        matchingReset(){
            this.searchString = ""
            this.matchingAjax()
        },
        handleSelectionChange1(val){
            this.ReturninventoryLists = val
        },
        handleSelectionChange_1(val){
            this.ReturninventoryLists1 = val
        },
        handleSelectionChange2(val){
            this.ReturninventoryList1s = val
        },
        save(){
            var obj = {
                loginRoleId:this.str.rid,
                type:1,
                inventorys:this.ReturninventoryLists,
                inventorys1:this.ReturninventoryLists1
            };
            ajaxPost(Baseurl + "inventoryController/insertInventoryCopy", obj).then(res => {
                if(res.data.code == 200){
                    this.innerVisibles = false
                    this.inventoryAjax()
                }else{
                    this.$message.error(res.data.data);
                }
            });
            // console.log(this.ReturninventoryLists)
        },
        handleSizeChange(val) {
            this.size = val;
            this.matchingAjax()
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.matchingAjax()
        },
        handleSizeChange1(val) {
            this.size1 = val;
            this.matchingAjax1()
        },
        handleCurrentChange1(val) {
            this.currentPage1 = val;
            this.matchingAjax1()
        },
        SelectLogistics1(val){
            // console.log(val)
            this.logisticsCompany1 = val.logisticsCompanyName
            this.companyCode1 = val.logisticsCompanyCode
        },
        SelectLogistics(val){
            // console.log(val)
            this.logisticsCompany = val.logisticsCompanyName
            this.companyCode = val.logisticsCompanyCode
        },
        HXShops(){
            this.Hymall = true
            this.tableLoading2 = true
            this.HXShopsSearch()
        },
        HXShopsSearch(){
            this.tableLoading2 = true
                var obj = {
                    page:1,
                    size:1000,
                    searchString:this.ShopsString
                };
                ajaxPost(Baseurl + "inventoryController/selectOnLineInventorysList",obj).then(res => {
                    if(res.data.code == 200){
                        this.GoodsMall = res.data.data.list
                    }
                    this.tableLoading2 = false
                });
        },
        HXShopsReset(){
            this.ShopsString = ""
            this.HXShopsSearch()
        },
        inventoryAjax(){
            var obj = {
                loginRoleId:this.str.rid,
            };
            // inventoryController/selectInventoryByDemandId
            ajaxPost(Baseurl + "inventoryController/selectInventoryCopyByRoleId", obj).then(res => {
                if(res.data.code == 200){
                    this.ReturninventoryList = res.data.data.inventorys
                    this.ReturninventoryList1 = res.data.data.mallInventorys
                }else{
                    this.$message.error(res.data.data);
                }
            });
        },
        save1(){
            var obj = {
                loginRoleId:this.str.rid,
                type:2,
                inventorys:this.ReturninventoryList1s,
                inventorys1: []
            };
            ajaxPost(Baseurl + "inventoryController/insertInventoryCopy", obj).then(res => {
                if(res.data.code == 200){
                    this.Hymall = false
                    this.inventoryAjax()
                }else{
                    this.$message.error(res.data.data);
                }
            });
        },
        delSave(val){
            // console.log(val)
            var obj = {
                id:val.id
            };
            ajaxPost(Baseurl + "inventoryController/deleteInventoryCopyById", obj).then(res => {
                if(res.data.code == 200){
                    this.inventoryAjax()
                }else{
                    this.$message.error(res.data.data);
                }
            });
        },
        delSave1(val){
            var obj = {
                id:val.id
            };
            ajaxPost(Baseurl + "inventoryController/deleteInventoryCopyById", obj).then(res => {
                if(res.data.code == 200){
                    this.inventoryAjax()
                }else{
                    this.$message.error(res.data.data);
                }
            });
        },
        cancelEC(type){
            const handleRequest = () => {
                let paramsData = {
                    id: this.infoData.id,
                    orderId: this.infoData.orderId,
                    purchaseDemandId: this.infoData.purchaseDemandId
                };
                const operate = {
                    Cancel: () => {
                        paramsData.exceptionResult = "5";
                        paramsData.inventorys = this.ReturninventoryList
                        paramsData.mallInventorys = this.ReturninventoryList1
                        this.cancelList = false
                        this.dialogVisible = false
                    }
                };
                operate[type]();
                this.$emit("confirm", paramsData);
            };
            this.$confirm("取消异常后将，该订单将按照最新匹配方案进行核对", "提示", {
                dangerouslyUseHTMLString: true
            }).then(() => {
                handleRequest();
            });
        },
        handleClose(done) {
          this.$confirm('点击关闭，该订单仍处于异常状态，库存及商城匹配无法保存，是否关闭', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
                }).then(() => {
                    var obj = {
                        loginRoleId:this.str.rid
                    };
                    ajaxPost(Baseurl + "inventoryController/deleteInventoryCopyByRoleId", obj).then(res => {
                        if(res.data.code == 200){
                            this.$message("已取消提交")
                        }else{
                            this.$message.error(res.data.data);
                        }
                        done();
                    });
                })
        },
        taginvalid(val){
            this.$confirm('点击标记为无效状态时，库房将对此条国内运单不再进行核对，是否确认标记', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning'
            }).then(() => {
                var obj = {
                    id:val.id,
                    roleId:this.str.rid
                };
                ajaxPost(Baseurl + "purchaseController/updateInvalidStatusById", obj).then(res => {
                    if(res.data.code == 200){
                        this.$message({
                            message: '标记为无效单据成功',
                            type: 'success'
                        });
                        this.demand()
                    }else{
                        this.$message.error(res.data.data);
                    }
                });
            })
            
        },
        toView(val){
            this.AddinnerVisible1 = true
            this.internalConveyNumber2 = val.internalConveyNumber
            this.purchasePrice2 = val.purchasePrice;
            this.rebatePrice2 = val.rebatePrice;
            this.purchaseModel2 = val.purchaseModel;
            this.logisticsCompany2 = val.logisticsCompany;
            this.purchaseTypeCode2 = val.purchaseTypeCode;
            this.remark2 = val.remark;
            this.otherPrice2 = val.otherPrice;
            this.companyCode2 = val.companyCode;
        },
        Add(){
            this.AddinnerVisible = true;
            this.LogisticsAjax()
            this.typeCode()
        },
        AddPurchasebCancel(){
                this.purchasePrice1 = ""
                this.rebatePrice1 = ""
                this.purchaseModel1 = ""
                this.logisticsCompany1 =""
                this.purchaseTypeCode1 =""
                this.remark1 = ""
                this.otherPrice1 = ""
                this.internalConveyNumber1 = ""
                this.AddinnerVisible = false
        },
        determine(val){
            this.$confirm('点击保存，采购方案即将新增一条新的采购单据，库房将对该订单按照新的采购方案进行核对。', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning'
            }).then(() => {
                if(this.internalConveyNumber1 == ""&&this.logisticsCompany1!==""){
                    this.$message.error("物流公司和运单号码必须同时填写")
                }else if(this.internalConveyNumber1 !== ""&&this.logisticsCompany1 ==""){
                    this.$message.error("物流公司和运单号码必须同时填写")
                }else{
                    var obj = {
                            roleId:this.str.rid,
                            purchaseRoleId:this.str.rid,
                            companyId:this.str.company_id,
                            purchaseFrom:1,
                            purchaseDemandId:this.purchaseDemandId.id,
                            internalConveyNumber: this.internalConveyNumber1,
                            purchasePrice: this.purchasePrice1,
                            rebatePrice: this.rebatePrice1,
                            purchaseModel: this.purchaseModel1,
                            logisticsCompany: this.logisticsCompany1,
                            purchaseTypeCode: this.purchaseTypeCode1,
                            remark: this.remark1,
                            otherPrice: this.otherPrice1,
                            companyCode:this.companyCode1,
                            insertFrom:1,
                            orderId:this.purchaseDemandId.orderId,
                            amazonOrderId:this.purchaseDemandId.amazonOrderId,
                    };
                    ajaxPost(Baseurl + "purchaseController/insertPurchase", obj).then(res => {
                        if(res.data.code == 200){
                            this.$message({
                                message: '添加成功',
                                type: 'success'
                            });
                            this.demand()
                            this.AddinnerVisible = false
                        }else{
                            this.$message.error(res.data.data);
                        }
                    });
                }
            })
        },
        Saves(){
            var obj = {
                roleId:this.UserInfo.rid,
                companyId:this.UserInfo.company_id,
                purchaseDemandId:this.id,
                inventorys:this.ReturninventoryList,
                mallInventorys:this.ReturninventoryList1,
                insertFrom:1
            };
                ajaxPost(Baseurl + "inventoryController/saveDemandInInventoryOperate", obj).then(res => {
                    if(res.data.code == 200){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.cancelList = false
                        this.dialogVisible = false
                    }else{
                        this.$message.error(res.data.data);
                    }
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.custom-container {
    padding: 0 20px;
    display: flex;
    align-items: center;
}
.inform {
    line-height: 30px;
    &.flex {
        display: flex;
        .title {
            flex-shrink: 0;
            font-weight: bold;
        }
    }
}
.right-btn-container {
    display: flex;
    justify-content: flex-end;
}
.el-popover {
    position: absolute;
    background: #fff;
    min-width: 200px;
    border: 1px solid #ebeef5;
    padding: 12px;
    left: 40%;
    right: 0%;
    top: -17%;
    color: #606266;
    line-height: 1.4;
    text-align: justify;
    font-size: 14px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    display: none;
    z-index: 9998;
    img {
        width: 90%;
    }
}
.padding0 {
    padding: 0;
}
.out-handle-box {
    padding-left: 15px;
}
.leix {
    background-color: #f5f7fa;
    line-height: 30px;
    padding: 5px;
    border-left: 1px solid #e4e7ed;
    border-bottom: 1px solid #e4e7ed;
    border-top: 1px solid #e4e7ed;
    color: #909399;
    border-radius: 4px 0px 0px 4px;
}
.padding {
    padding: 10px 0;
}
.product{
    display: flex;
    justify-content: left;
}
.product p{
    text-align: left;
}

.redFont {
    color: red;
}
.danjuremark {
    height: 60px;
    line-height: 60px;
}
</style>
